export const PUBLIC_CHAT_EXAMPLES_SCHEMA_VERSION = 1;
export const MAX_PUBLIC_CHAT_EXAMPLES = 24;

const REVISION_PATTERN = /^sha256-[a-f0-9]{64}$/u;
const KEY_PATTERN = /^[a-z0-9]+(?:_[a-z0-9]+)*$/u;
const THREAD_ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/u;

const isPlainObject = (value) => (
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value)
);

const requireTrimmedString = (value, { maxLength, pattern = null } = {}) => {
    if (typeof value !== 'string' || value.length === 0 || value !== value.trim()) {
        throw new Error('Invalid public chat examples response.');
    }
    if (maxLength && Array.from(value).length > maxLength) {
        throw new Error('Invalid public chat examples response.');
    }
    if (pattern && !pattern.test(value)) {
        throw new Error('Invalid public chat examples response.');
    }

    return value;
};

export const validatePublicChatExamplesManifest = (value) => {
    if (!isPlainObject(value) || value.schemaVersion !== PUBLIC_CHAT_EXAMPLES_SCHEMA_VERSION) {
        throw new Error('Invalid public chat examples response.');
    }

    const revision = requireTrimmedString(value.revision, {
        pattern: REVISION_PATTERN,
    });
    const publishedAt = requireTrimmedString(value.publishedAt, { maxLength: 64 });
    if (!Number.isFinite(Date.parse(publishedAt))) {
        throw new Error('Invalid public chat examples response.');
    }
    if (!Array.isArray(value.examples) || value.examples.length > MAX_PUBLIC_CHAT_EXAMPLES) {
        throw new Error('Invalid public chat examples response.');
    }

    const usedKeys = new Set();
    const usedThreadIds = new Set();
    const usedLabels = new Set();
    const examples = value.examples.map((example) => {
        if (!isPlainObject(example)) {
            throw new Error('Invalid public chat examples response.');
        }

        const key = requireTrimmedString(example.key, {
            maxLength: 80,
            pattern: KEY_PATTERN,
        });
        const threadId = requireTrimmedString(example.threadId, {
            pattern: THREAD_ID_PATTERN,
        });
        const label = requireTrimmedString(example.label, { maxLength: 120 });
        const emoji = requireTrimmedString(example.emoji, { maxLength: 16 });
        const normalizedLabel = label.normalize('NFKC').toLowerCase();
        if (
            !normalizedLabel ||
            usedKeys.has(key) ||
            usedThreadIds.has(threadId) ||
            usedLabels.has(normalizedLabel)
        ) {
            throw new Error('Invalid public chat examples response.');
        }

        usedKeys.add(key);
        usedThreadIds.add(threadId);
        usedLabels.add(normalizedLabel);
        return { key, threadId, label, emoji };
    });

    return {
        schemaVersion: PUBLIC_CHAT_EXAMPLES_SCHEMA_VERSION,
        revision,
        publishedAt,
        examples,
    };
};
